import { createSlice, current } from "@reduxjs/toolkit";
import {
  getProfileDetail,
  addOrUpdateProvider,
  deleteAcc,
  changePassWord,
  getQrCOde,
  getInquirys,
} from "../thunks/profileThunk";

const initialState = {
  isLoading: false,
  username: null,
  useremail: null,
  userimg: null,
  usernumber: null,
  userconId: null,
  useravtar: null,
  userImg: null,
  userQrCode: null,
  country_id: null,
  userError: "",
  pagination: {
    current_page: 1,
    total_pages: 1,
    total_records: 0,
  },
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProfileDetail.pending, (state) => {
        state.isLoading = true;
        state.userError = null;
      })
      .addCase(getProfileDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        // save data from API response
        const data = action.payload?.data || {};
        state.username = data.name || null;
        state.useremail = data.email || null;
        state.userimg = data.user_profile_image || null;
        state.usernumber = data.contact_no || null;
        ((state.country_id = data.country_id || null),
          (state.userQrCode = data.qrCode || null));
      })
      .addCase(getProfileDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.userError = action.payload;
      })
      .addCase(addOrUpdateProvider.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addOrUpdateProvider.fulfilled, (state, action) => {
        state.isLoading = false;
        state.action = action.payload.data;
      })
      .addCase(addOrUpdateProvider.rejected, (state, action) => {
        state.isLoading = false;
        state.action = action.error;
      })
      .addCase(changePassWord.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(changePassWord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.action = action.payload.data;
      })
      .addCase(changePassWord.rejected, (state, action) => {
        state.isLoading = false;
        state.action = action.error;
      })
      .addCase(deleteAcc.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAcc.fulfilled, (state, action) => {
        state.isLoading = false;
        state.action = action.payload.data;
      })
      .addCase(deleteAcc.rejected, (state, action) => {
        state.isLoading = false;
        state.action = action.error;
      })
      .addCase(getQrCOde.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getQrCOde.fulfilled, (state, action) => {
        state.isLoading = false;
        state.action = action.payload;
      })
      .addCase(getQrCOde.rejected, (state, action) => {
        state.isLoading = false;
        state.action = action.error;
      })
      .addCase(getInquirys.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInquirys.fulfilled, (state, action) => {
        state.isLoading = false;
        const data = action.payload.data;
        state.action = action.payload;
        ((state.pagination.current_page = data.current_page),
          (state.pagination.total_pages = data.total_pages),
          (state.pagination.total_records = data.total_records));
      })
      .addCase(getInquirys.rejected, (state) => {
        state.isLoading = false;
      });
  },
});
export default profileSlice.reducer;
